import axios from "axios";
import { useQuery } from "react-query";

const useGetServicePointLocation = ({ postalCode, countryCode }) => {
  const query = useQuery(
    ["service-point-locations", postalCode, countryCode],
    async () => {
      const response = await axios.get(
        `https://api.dhl.com/location-finder/v1/find-by-address?postalCode=${postalCode}&countryCode=${countryCode}`,
        {
          headers: {
            "DHL-API-Key": process.env.REACT_APP_DHL_API_KEY, // or your actual key
          },
        }
      );
      return response.data;
    },
    {
      enabled: !!postalCode && !!countryCode, // only fetch when postalCode and countryCode both exists
    }
  );

  return query;
};

export default useGetServicePointLocation;
